export const SUPPORTED_LANGUAGES = [
  {
    title: 'azerbaijani',
    ID: 'AZERBAIJANI',
    code: 'az'
  },
  {
    title: 'bengali',
    ID: 'BENGALI',
    code: 'bn'
  },
  {
    title: 'bulgarian',
    ID: 'BULGARIAN',
    code: 'bg'
  },
  {
    title: 'catalan',
    ID: 'CATALAN',
    code: 'ca'
  },
  {
    title: 'chinese-simplified',
    ID: 'CHINESE_SIMPLIFIED',
    code: 'zh-CN'
  },
  {
    title: 'chinese-traditional',
    ID: 'CHINESE_TRADITIONAL',
    code: 'zh-TW'
  },
  {
    title: 'croatian',
    ID: 'CROATIAN',
    code: 'hr'
  },
  {
    title: 'czech',
    ID: 'CZECH',
    code: 'cs'
  },
  {
    title: 'danish',
    ID: 'DANISH',
    code: 'da'
  },
  {
    title: 'dutch',
    ID: 'DUTCH',
    code: 'nl'
  },
  {
    title: 'egyptian-arabic',
    ID: 'EGYPTIAN_ARABIC',
    code: 'ar'
  },
  {
    title: 'english-uk',
    ID: 'ENGLISH_UK',
    code: 'en-GB'
  },
  {
    title: 'english-us',
    ID: 'ENGLISH_US',
    code: 'en-US'
  },
  {
    title: 'estonian',
    ID: 'ESTONIAN',
    code: 'et'
  },
  {
    title: 'finnish',
    ID: 'FINNISH',
    code: 'fi'
  },
  {
    title: 'french',
    ID: 'FRENCH',
    code: 'fr'
  },
  {
    title: 'german',
    ID: 'GERMAN',
    code: 'de'
  },
  {
    title: 'greek',
    ID: 'GREEK',
    code: 'el'
  },
  {
    title: 'hausa',
    ID: 'HAUSA',
    code: 'ha'
  },
  {
    title: 'hebrew',
    ID: 'HEBREW',
    code: 'he'
  },
  {
    title: 'hindi',
    ID: 'HINDI',
    code: 'hi'
  },
  {
    title: 'hungarian',
    ID: 'HUNGARIAN',
    code: 'hu'
  },
  {
    title: 'indonesian',
    ID: 'INDONESIAN',
    code: 'id'
  },
  {
    title: 'italian',
    ID: 'ITALIAN',
    code: 'it'
  },
  {
    title: 'japanese',
    ID: 'JAPANESE',
    code: 'ja'
  },
  {
    title: 'javanese',
    ID: 'JAVANESE',
    code: 'jv'
  },
  {
    title: 'korean',
    ID: 'KOREAN',
    code: 'ko'
  },
  {
    title: 'latvian',
    ID: 'LATVIAN',
    code: 'lv'
  },
  {
    title: 'lithuanian',
    ID: 'LITHUANIAN',
    code: 'lt'
  },
  {
    title: 'norwegian',
    ID: 'NORWEGIAN',
    code: 'no'
  },
  {
    title: 'persian',
    ID: 'PERSIAN',
    code: 'fa'
  },
  {
    title: 'polish',
    ID: 'POLISH',
    code: 'pl'
  },
  {
    title: 'portuguese',
    ID: 'PORTUGUESE',
    code: 'pt'
  },
  {
    title: 'romanian',
    ID: 'ROMANIAN',
    code: 'ro'
  },
  {
    title: 'russian',
    ID: 'RUSSIAN',
    code: 'ru'
  },
  {
    title: 'serbian',
    ID: 'SERBIAN',
    code: 'sr'
  },
  {
    title: 'slovak',
    ID: 'SLOVAK',
    code: 'sk'
  },
  {
    title: 'slovenian',
    ID: 'SLOVENIAN',
    code: 'sl'
  },
  {
    title: 'spanish',
    ID: 'SPANISH',
    code: 'es'
  },
  {
    title: 'standard-arabic',
    ID: 'STANDARD_ARABIC',
    code: 'ar'
  },
  {
    title: 'swahili',
    ID: 'SWAHILI',
    code: 'sw'
  },
  {
    title: 'swedish',
    ID: 'SWEDISH',
    code: 'sv'
  },
  {
    title: 'thai',
    ID: 'THAI',
    code: 'th'
  },
  {
    title: 'turkish',
    ID: 'TURKISH',
    code: 'tk'
  },
  {
    title: 'ukrainian',
    ID: 'UKRAINIAN',
    code: 'uk'
  },
  {
    title: 'vietnamese',
    ID: 'VIETNAMESE',
    code: 'vi'
  },
  {
    title: 'zulu',
    ID: 'ZULU',
    code: 'zu'
  }
]

export const translationLanguages = ['en-US', 'en-GB', 'da', 'de', 'es', 'fi', 'fr', 'it', 'nb', 'sv', 'nl', 'ru']
